import { useAnalyticsIdentity } from '@portal/features/analytics/useAnalyticsIdentity'
import { requireAuth } from '@portal/features/auth/guards'
import AppSplash from '@portal/features/feedback/AppSplash'
import MainLayout from '@portal/features/layouts/MainLayout'
import { ensureProfile } from '@portal/features/profile/guards'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const RouteComponent = () => {
  // Mounted here so it runs once per session for every authenticated page.
  // Stays alive for the lifetime of the _app layout — re-identifies automatically
  // whenever the profile query cache is refreshed (e.g. after a profile save).
  useAnalyticsIdentity()

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}

export const Route = createFileRoute('/_app')({
  beforeLoad: requireAuth,
  loader: ensureProfile,
  pendingComponent: AppSplash,
  component: RouteComponent,
})
